import dotenv from "dotenv";
dotenv.config();

import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import store from "./store";
import router from "./router";
import axios, { isAuthenticated, API_URL } from "./helpers/axios";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import CKEditor from "ckeditor4-vue/dist/legacy.js";
import "animate.css";
import VueConfetti from "vue-confetti";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "vue2-animate/dist/vue2-animate.min.css";
import "video.js/dist/video-js.css";
import VueSession from "vue-session";
import VueTheMask from "vue-the-mask";
import i18n from "@/locales/i18n";
import Default from "./layouts/default";
import Login from "./layouts/login";
import AdmAcademico from "./layouts/administrativo_academico";
import mensajeSistema from "./components/mensajeSistema";
import loadingSistema from "./components/loading.vue";
import confirm from "./components/confirm";
import { Files } from "./functions/files";
import "@/functions/filters";
import moment from "vue-moment";
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css'; 
import "@/assets/css/global.css";
import "./assets/css/helpers.scss";


/*
 _________________________________________________________
|                   COMPONENTES                         */
Vue.component("default_layout", Default);
Vue.component("login_layout", Login);
Vue.component("adm_academico_layout", AdmAcademico);
// Vue.component("mensajeSistema", mensajeSistema);
Vue.component('AgGridVue', AgGridVue);
Vue.component("confirm", confirm);
// Vue.component("inactive", inactive);
Vue.component("mensajeSistema", mensajeSistema);
Vue.component("loadingSistema", loadingSistema);
/*
 _________________________________________________________
|                        USE                             */
Vue.use(CKEditor);
Vue.use(PerfectScrollbar);
Vue.use(VueConfetti);
Vue.use(VueTheMask);
Vue.use(Toast);
Vue.use(moment);
Vue.use(VueSession);
/*
 _________________________________________________________
|                   GLOBAL STATES                        */
const states = {
  success: "S",
  warning: "W",
  error: "E",
};
/*
 _________________________________________________________
|                   PROTOTYPE                           */
Vue.prototype.$states = states;
Vue.prototype.$Files = Files;
Vue.prototype.$http = axios;
Vue.config.productionTip = true;

/*
 _________________________________________________________
|     INTERCEPTORS AXIOS - VALIDATE SESION THROW TOKEN   */
axios.defaults.headers.post["Content-Type"] = "application/json";

/*
 _________________________________________________________
|                   CORS                                */
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
/*
 _________________________________________________________
|                REQUEST INTERCEPTORS                    */
axios.interceptors.request.use(
  async config => {
    const token = await isAuthenticated();
    if(token){
 
      config.headers["Authorization"] = `Bearer ${token}`
      config.headers.baseURL = API_URL;
    
    }
    return config;
  },
   error => {
    return Promise.reject(error);
  }
);
/*
 _________________________________________________________
|                   RESPONDE INTERCEPTORS               */
axios.interceptors.response.use(
  function(response) {
    if (
      response.data != null &&
      response.data.access !== undefined &&
      !response.data.access
    ) {
      location.href = "./logout";
    }
    return response;
  },
  function(error) {
    console.log("error:", error);
    return Promise.reject(error);
  }
);

new Vue({
  router,
  Vuex,
  store,
  vuetify,
  axios,
  CKEditor,
  VueTheMask,
  i18n,
  render: (h) => h(App),
}).$mount("#app");